/**
 * 라이브러리에서 대화 산출물 목록을 볼 때 쓰는 읽기 전용 조회.
 * 목록 화면에서는 호출하지 않고, 받기/이어 수정 클릭 시에만 1회 읽는다.
 */

import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase/config';

const deserializeOutline = (raw) => {
  if (raw == null) return null;
  if (typeof raw === 'string') {
    try { return JSON.parse(raw); } catch (_error) { return null; }
  }
  return raw;
};

export const normalizeConversationDoc = (id, data = {}) => ({
  id,
  userId: data.userId || null,
  lastCategory: data.lastCategory || null,
  pptDownloadUrl: data.pptDownloadUrl || null,
  pptFilename: data.pptFilename || null,
  pptOutline: deserializeOutline(data.pptOutline),
  pptPreviewUrls: data.pptPreviewUrls || null,
  pptOriginalUrls: data.pptOriginalUrls || null,
  pptDownloadMode: data.pptDownloadMode || null,
  pptActiveVersionId: data.pptActiveVersionId || null,
  pptArtifacts: Array.isArray(data.pptArtifacts) ? data.pptArtifacts : [],
  worksheetOutline: deserializeOutline(data.worksheetOutline),
  worksheetDownloadUrl: data.worksheetDownloadUrl || null,
  worksheetFilename: data.worksheetFilename || null,
  worksheetPreviewUrls: data.worksheetPreviewUrls || null,
  worksheetOriginalUrls: data.worksheetOriginalUrls || null,
  worksheetActiveVersionId: data.worksheetActiveVersionId || null,
  worksheetCanvas: deserializeOutline(data.worksheetCanvas),
  worksheetCanvasVersionId: data.worksheetCanvasVersionId || null,
  worksheetArtifacts: Array.isArray(data.worksheetArtifacts) ? data.worksheetArtifacts : [],
});

export async function loadOwnedConversation(conversationId, uid) {
  if (!conversationId || !uid) return null;
  const snapshot = await getDoc(doc(db, 'conversations', conversationId));
  if (!snapshot.exists()) return null;
  const data = snapshot.data() || {};
  if (data.userId && data.userId !== uid) return null;
  return normalizeConversationDoc(snapshot.id, data);
}
